import {useEffect, useState} from 'react';

function getWindowDimensions() {
    const {innerWidth: width, innerHeight: height} = window;
    return {
        width,
        height
    };
}

export function useWindowSize() {
    const [width, setWidth] = useState(getWindowDimensions().width);
    const [height, setHeight] = useState(getWindowDimensions().height);
    useEffect(() => {
        function handleResize() {
            setWidth(getWindowDimensions().width);
            setHeight(getWindowDimensions().height);
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return { width, height };
}